<template>
  <v-main app :class="{ 'v-main--logged-in': isLoggedInUser, 'v-main--logged-out': !isLoggedInUser }">
    <!-- Provides the application the proper gutter -->
    <div class="d-flex flex-column flex-grow-1 h-full">
      <v-container class="main-container pa-0 d-flex flex-column flex-grow-1" fluid>
        <!-- If using vue-router -->

        <!-- <customizer /> -->
        <transition mode="out-in">
          <router-view />
        </transition>
      </v-container>
      <app-footer v-if="!isRouteIncluded" />
    </div>
  </v-main>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    components: {
      AppFooter: () => import('./Footer'),
    },
    computed: {
      ...mapGetters(['getThemeMode']),

      isLoggedInUser() {
        const userExists = !!this.$store.getters.getuser;
        return userExists && !this.isSocialSignUp;
      },

      isRouteIncluded() {
        return this.$store.getters.checkStringInArray(this.$router.history.current.name); // Pass the string to check here
      },
    },
  };
</script>

<style lang="scss">
  html {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .v-main__wrap {
    flex: 1 1 auto;
    max-width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  @media only screen and (max-width: 1666px) {
    .v-main .container .row > .container.fill-height:first-of-type,
    .v-main .pvp-lg,
    .v-main .bannerVideoLogo {
      padding-top: 40px !important;
    }
  }

  @media only screen and (max-width: 960px) {
    .v-main .container .row > .container.fill-height:first-of-type,
    .v-main .pvp-lg,
    .v-main .bannerVideoLogo {
      padding-top: 48px !important;
    }
  }

  @media only screen and (max-width: 600px) {
    .v-main .container .row > .container.fill-height:first-of-type,
    .v-main .pvp-lg,
    .v-main .bannerVideoLogo {
      padding-top: 38px !important;
    }
  }
</style>
